<template>
  <BCard
    v-if="data"
    class="h-100 "
  >
    <!-- title and dropdown -->
    <BCardHeader class="p-0">
      <BCardTitle> Facturas pagadas este mes </BCardTitle>
    </BCardHeader>
    <!--/ title and dropdown -->

    <BCardBody>
      <BRow>
        <!-- <BCol
          sm="2"
          class="d-flex flex-column flex-wrap text-center"
        >
          <h1 class="font-large-2 font-weight-bolder mt-2 mb-0">
            Total
          </h1>
          <small>{{data.total}}</small>
        </BCol> -->

        <!-- chart -->
        <BCol
          
          class="d-flex justify-content-center"
        >

          <!-- apex chart -->
          <vue-apex-charts
            type="radialBar"
            height="270"
            :options="supportTrackerRadialBar.chartOptions"
            :series="[data.total!=0 ? (data.part/data.total*100).toFixed(2):0]"
          />
        </BCol>
        <!--/ chart -->
      </BRow>

      <!-- chart info -->
      <BCol class="d-flex justify-content-between">

        <div class="text-center">
          <BCardText class="mb-50">
            Total
          </BCardText>
          <span class="font-large-1 font-weight-bold"> {{data.total}}</span>
        </div>
        <div class="text-center">
          <BCardText class="mb-50">
            Pagadas
          </BCardText>
          <span class="font-large-1 font-weight-bold"> {{data.part}}</span>
        </div>
        <div class="text-center">
          <BCardText class="mb-50">
            Pendientes
          </BCardText>
          <span class="font-large-1 font-weight-bold"> {{data.total-data.part}}</span>
        </div>
      </BCol>
    </BCardBody>
  </BCard>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BDropdown, BDropdownItem, BCardBody, BRow, BCol, BCardText,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BCardText,
    BCardBody,
    BRow,
    BCol,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      supportTrackerRadialBar: {
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: 20,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '65%',
              },
              track: {
                background: '#fff',
                strokeWidth: '100%',
              },
              dataLabels: {
                name: {
                  offsetY: -5,
                  color: '#5e5873',
                  fontSize: '1rem',
                },
                value: {
                  offsetY: 15,
                  color: '#5e5873',
                  fontSize: '1.714rem',
                },
              },
            },
          },
          colors: [$themeColors.success],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.success],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            dashArray: 8,
          },
          labels: ["Facturas pagadas"],
        },
      },
    }
  },
}
</script>
